import { map, Observable } from "rxjs";
import { Game, List, ListDisplayType } from "../../model";
import { apiService } from "../ApiService";

export const getBonusGamesList = (): Observable<List> => {
  return apiService
    .get<{ games: Game[]; meta: { total: number } }>({
      path: `public/games/bonus`,
      requiresAuthPolicy: "user",
      edito: true,
    })
    .pipe(
      map((res) => ({
        display: ListDisplayType.BONUS_GAMES,
        isPaginated: false,
        tiles: res.games.map((g) => ({ game: g })),
        total: res.meta.total,
        uuid: "",
      })),
    );
};
